module.exports = __webpack_public_path__ + "img/cdk_3.dafa6c3a.png";